/* eslint-disable react/require-default-props */
import * as React from 'react';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { Browser } from '@capacitor/browser';
import InheritedColorLink from './DefaultLink';
import { brandingColourHeavy } from '../cssConstants';

const ExternalLink = ({ href, underlined = true, children, target = '_blank', className = undefined }: Props) => {
	return (
		<StyledLink
			className={className}
			$underlined={underlined}
			href={href}
			onClick={async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
				e.preventDefault();
				await openExternalURL(href);
			}}
			target={target}
			rel="noopener noreferrer"
		>
			{children}
		</StyledLink>
	);
};

export default ExternalLink;

export const BrandingBlueExternalLink = styled(ExternalLink)`
	color: ${brandingColourHeavy};
`;

interface Props {
	className?: string;
	href: string;
	children: ReactNode;
	// For web app only
	target?: string;
	underlined?: boolean;
}

export const openExternalURL = async (url: string) => {
	try {
		await Browser.open({ url });
	} catch (error) {
		// Log the error but don't let it become an unhandled rejection
		// This can happen on iOS when the browser fails to open certain URLs
		console.warn('Failed to open external URL:', url, error);
	}
};

const StyledLink = styled(InheritedColorLink) <{ $underlined: boolean }>`
	text-decoration: ${(props) => (props.$underlined ? 'underline' : 'none')};
`;
